// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root Wrapper */
.MonthlyReport-report-wrapper {
  max-width: 1200px;
  margin: auto;
  padding: 24px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f9f9f9;
  color: #333;
}

/* Heading */
.MonthlyReport-report-heading {
  text-align: center;
  font-size: 28px;
  margin-bottom: 24px;
  color: #2c3e50;
}

/* Form */
.MonthlyReport-filter-form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 24px;
  background: #fff;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.MonthlyReport-form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.MonthlyReport-form-group label {
  margin-bottom: 6px;
  font-weight: 600;
  color: #555;
}

.MonthlyReport-form-group select,
.MonthlyReport-form-group input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

/* Submit Button */
.MonthlyReport-btn-submit {
  padding: 10px 20px;
  background-color: #2d7eff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 26px;
  transition: background-color 0.3s ease;
}

.MonthlyReport-btn-submit:hover {
  background-color: #1a5fd2;
}

/* Loading */
.MonthlyReport-loading-text {
  text-align: center;
  font-size: 16px;
  color: #888;
}

/* Table */
.MonthlyReport-table-scroll {
  overflow-x: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.MonthlyReport-monthly-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.MonthlyReport-monthly-table th,
.MonthlyReport-monthly-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 13px;
}

.MonthlyReport-monthly-table th {
  background-color: #f1f5f9;
  font-weight: 600;
}

.MonthlyReport-emp-name {
  text-align: left;
  font-weight: 500;
}

.MonthlyReport-status-cell {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
}

/* Status Colors */
.MonthlyReport-present-status {
  background-color: #d1f5d3;
  color: #207a22;
}

.MonthlyReport-absent-status {
  background-color: #ffd6d6;
  color: #c0392b;
}

.MonthlyReport-halfday-status {
  background-color: #fff3cd;
  color: #856404;
}

.MonthlyReport-na-status {
  background-color: #f0f0f0;
  color: #999;
}

/* Summary Section */
.MonthlyReport-summary-header {
  text-align: center;
  margin-bottom: 12px;
  color: #2c3e50;
}

.MonthlyReport-summary-header h4 {
  font-size: 16px;
  margin: 0;
}

.MonthlyReport-summary-row {
  font-weight: bold;
}

.MonthlyReport-present-row td,
.MonthlyReport-absent-row td,
.MonthlyReport-halfday-row td {
  font-size: 12px;
}

.MonthlyReport-actions {
  margin: 10px 0;
}

.MonthlyReport-btn-print,
.MonthlyReport-btn-pdf {
  padding: 8px 12px;
  margin-right: 8px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.MonthlyReport-btn-print:hover,
.MonthlyReport-btn-pdf:hover {
  background-color: #0056b3;
}

.MonthlyReport-monthly-table th,
.MonthlyReport-monthly-table td {
  white-space: nowrap;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Attendance/MonthlyReport.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,4DAA4D;EAC5D,yBAAyB;EACzB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["/* Root Wrapper */\n.MonthlyReport-report-wrapper {\n  max-width: 1200px;\n  margin: auto;\n  padding: 24px;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  background-color: #f9f9f9;\n  color: #333;\n}\n\n/* Heading */\n.MonthlyReport-report-heading {\n  text-align: center;\n  font-size: 28px;\n  margin-bottom: 24px;\n  color: #2c3e50;\n}\n\n/* Form */\n.MonthlyReport-filter-form {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 24px;\n  background: #fff;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n}\n\n.MonthlyReport-form-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.MonthlyReport-form-group label {\n  margin-bottom: 6px;\n  font-weight: 600;\n  color: #555;\n}\n\n.MonthlyReport-form-group select,\n.MonthlyReport-form-group input {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n/* Submit Button */\n.MonthlyReport-btn-submit {\n  padding: 10px 20px;\n  background-color: #2d7eff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  margin-top: 26px;\n  transition: background-color 0.3s ease;\n}\n\n.MonthlyReport-btn-submit:hover {\n  background-color: #1a5fd2;\n}\n\n/* Loading */\n.MonthlyReport-loading-text {\n  text-align: center;\n  font-size: 16px;\n  color: #888;\n}\n\n/* Table */\n.MonthlyReport-table-scroll {\n  overflow-x: auto;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n}\n\n.MonthlyReport-monthly-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px;\n}\n\n.MonthlyReport-monthly-table th,\n.MonthlyReport-monthly-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n  font-size: 13px;\n}\n\n.MonthlyReport-monthly-table th {\n  background-color: #f1f5f9;\n  font-weight: 600;\n}\n\n.MonthlyReport-emp-name {\n  text-align: left;\n  font-weight: 500;\n}\n\n.MonthlyReport-status-cell {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* Status Colors */\n.MonthlyReport-present-status {\n  background-color: #d1f5d3;\n  color: #207a22;\n}\n\n.MonthlyReport-absent-status {\n  background-color: #ffd6d6;\n  color: #c0392b;\n}\n\n.MonthlyReport-halfday-status {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.MonthlyReport-na-status {\n  background-color: #f0f0f0;\n  color: #999;\n}\n\n/* Summary Section */\n.MonthlyReport-summary-header {\n  text-align: center;\n  margin-bottom: 12px;\n  color: #2c3e50;\n}\n\n.MonthlyReport-summary-header h4 {\n  font-size: 16px;\n  margin: 0;\n}\n\n.MonthlyReport-summary-row {\n  font-weight: bold;\n}\n\n.MonthlyReport-present-row td,\n.MonthlyReport-absent-row td,\n.MonthlyReport-halfday-row td {\n  font-size: 12px;\n}\n\n.MonthlyReport-actions {\n  margin: 10px 0;\n}\n\n.MonthlyReport-btn-print,\n.MonthlyReport-btn-pdf {\n  padding: 8px 12px;\n  margin-right: 8px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.MonthlyReport-btn-print:hover,\n.MonthlyReport-btn-pdf:hover {\n  background-color: #0056b3;\n}\n\n.MonthlyReport-monthly-table th,\n.MonthlyReport-monthly-table td {\n  white-space: nowrap;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
